import { schema } from 'normalizr';

export const TEAM_SCHEMA_KEY = 'team';

// We are intentionally NOT normalizing 'team.users', as a user can have different
// roles/properties/etc on the various teams he/she is a part of. Normalizing this would
// result in the join table properties becoming lost.

// export const userSchema = new schema.Entity(
//   USERS,
//   {},
//   {
//     idAttribute: value => {
//       return value.user_id;
//     },
//   }
// );
// export const teamSchema = new schema.Entity(TEAM_SCHEMA_KEY, {
//   users: [userSchema],
// });

export const teamSchema = new schema.Entity(TEAM_SCHEMA_KEY);

export const teamListSchema = [teamSchema];
